document.addEventListener("DOMContentLoaded", () => {
    // Check if the body has the "error404" class
    const body = document.body;

    if (body.classList.contains("error404")) {
        // Select both parts of the footer
        const MainFooter = document.querySelector('section[data-block="footer-main"]');
        const BottomFooter = document.querySelector('section[data-block="footer-bottom"]');
        
        // Hide both parts of the footer
        MainFooter.style.display = "none";
        BottomFooter.style.display = "none";
    }
});